@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.tagButton {
  @include t.text(12px, 20px, 500);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  padding: 2px 10px;
  background-color: v.$palette-gray-200;
  color: v.$palette-accent;
  border-radius: 24px;
  cursor: pointer;
  height: 100%;
  user-select: none;
  width: 70px;
  position: relative;
  transition: all 0.2s;

  &::before {
    content: "";
    position: absolute;
    bottom: calc(100% + 2px);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 6px 0 6px;
    border-color: v.$palette-blue transparent transparent transparent;
    line-height: 0;
    _border-color: v.$palette-blue #000000 #000000 #000000;
    _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
    transition: all 0.2s;
    opacity: 0;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }

  &.active {
    background-color: v.$palette-blue;
    color: #fff;
    width: auto;

    &::before,
    .tooltip {
      display: none;
    }
  }

  &.uncovered {
    width: auto;

    &::before,
    .tooltip {
      display: none;
    }
  }

  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 4px;
    position: relative;
  }

  .tooltip {
    box-sizing: border-box;
    pointer-events: none;
    position: absolute;
    opacity: 0;
    transition: opacity 0.2s;
    border-radius: 8px;
    bottom: calc(100% + 10px);
    z-index: v.$z-index-tag-tooltip;
    background-color: v.$palette-blue;
    color: #fff;
    word-wrap: break-word;
    padding: 6px 12px;
    width: max-content;
  }

  &:hover {
    .tooltip {
      opacity: 1;
    }
  }
}

